import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import {
  setAlertDefault,
  setErrorAlert,
  setSuccessAlert,
} from "../features/app/alert/alertSlice";

export const generateXLAndDownload = (data, type) => {
  // const worksheetData = [Object.keys(data[0]), ...data.map(Object.values)];
  // worksheetData[0] = headers;
  // const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
  const buffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  FileSaver.saveAs(blob, `${type}_list_${new Date().getTime()}.xlsx`);
};

export const isInViewport = (element) => {
  // even if partially in viewport
  const rect = element.getBoundingClientRect();
  return (
    rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
    rect.bottom > 0 &&
    rect.left < (window.innerWidth || document.documentElement.clientWidth) &&
    rect.right > 0
  );
};

export const debounce = (func, delay) => {
  let timerId;
  return (...args) => {
    if (timerId) {
      clearTimeout(timerId);
    }
    timerId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

export const successAlertHandle = (msg, dispatch) => {
  dispatch(setSuccessAlert({ msg: msg }));
  setTimeout(() => {
    dispatch(setAlertDefault());
  }, 7500);
};

export const errorAlertHandle = (err, dispatch) => {
  if (!err.response) {
    dispatch(setErrorAlert({ error: "Something went wrong!" }));
    throw err;
  }
  dispatch(setErrorAlert({ error: err.response.data.error.message }));
  setTimeout(() => {
    dispatch(setAlertDefault());
  }, 7500);
};
